<div class="buttonPanel mat-elevation-z3">
  <span>
    <button mat-button (click)="closeDialog()" [disabled]="!camera.isStart">
      <mat-icon>keyboard_backspace</mat-icon>
      <span *ngIf="!isHandset()">{{ 'Generic.back' | translate }}</span>
    </button>
  </span>
</div>
<ngx-scanner-qrcode
  #camera="scanner"
  (event)="selectQRCode($event)"
></ngx-scanner-qrcode>
<br />
<div
  *ngIf="camera.devices.value.length > 1"
  style="display: flex; justify-content: center"
>
  <button mat-fab color="primary" (click)="changeCamera()">
    <mat-icon>switch_camera</mat-icon>
  </button>
</div>
